import { gql } from "apollo-angular";

export const FIND_PAPER_CONFIGURATIONS_BY_PUBLISHER = gql`
  query findPaperConfigurationsByPublisher($publisherId: UUID!) {
    findPaperConfigurationsByPublisher(publisherId: $publisherId) {
      id
      publisherId
      description
      ppi
      rollWidth
      basisWeight
      paperCoat
      stock
      color
      colorShort
      customerFurnished
      enabled
    }
  }
`;

export const GET_PAPER_CONFIGURATION = gql`
  query getPaperConfiguration($id: UUID!) {
    getPaperConfiguration(id: $id) {
      id
      publisherId
      description
      ppi
      rollWidth
      basisWeight
      paperCoat
      stock
      color
      colorShort
      customerFurnished
      enabled
    }
  }
`;

export const CREATE_PAPER_CONFIGURATION = gql`
  mutation createPaperConfiguration($input: PaperConfigurationInput!) {
    createPaperConfiguration(input: $input) {
      id
      publisherId
      description
      ppi
      rollWidth
      basisWeight
      paperCoat
      stock
      color
      colorShort
      customerFurnished
      enabled
    }
  }
`;

export const UPDATE_PAPER_CONFIGURATION = gql`
  mutation updatePaperConfiguration($input: PaperConfigurationUpdateInput!) {
    updatePaperConfiguration(input: $input) {
      id
      publisherId
      description
      ppi
      rollWidth
      basisWeight
      paperCoat
      stock
      color
      colorShort
      customerFurnished
      enabled
    }
  }
`;

export const DELETE_PAPER_CONFIGURATION = gql`
  mutation deletePaperConfiguration($id: UUID!) {
    deletePaperConfiguration(id: $id)
  }
`;
